import getDocumentType from './getDocumentType';

const isPreviewSupported = (documentName) => {
  const documentType = getDocumentType(documentName).toLowerCase();
  return ['txt', 'docx', 'doc', 'xlsx', 'xls', 'pdf'].includes(documentType);
};

export default isPreviewSupported;
